import { getTestAttributes } from '@chillibean/component-library';
import { PropTypes } from 'prop-types';

import { hasValue } from '../../../../../../../__util__/Table/formHelpers';
import { TextField } from '../../../../../../../primitives/form/TextField/TextField';

function FormTemplateHeader(props) {
  const {
    formTemplate,
    handleTemplateChange,
    handleTemplateHeaderOnBlur,
    handleTemplateHeaderOnClick,
    validateTemplateHeader,
    readOnly = false,
  } = props;
  const { description, title, id } = formTemplate;

  return (
    <>
      <div className="form-template-header__title-section-wrapper">
        <div className="form-template-header__title-section">
          <div className="form-template-header__title">
            {id && <div className="form-template-header__id">{id}</div>}
            <h1 {...getTestAttributes('form-template-header-title')}>{title || 'New Form'}</h1>
            <div
              className="form-template-header__description"
              {...getTestAttributes('form-template-header-description')}
            >
              {description || 'Form description'}
            </div>
          </div>
        </div>
      </div>
      <div className="form__group-wrapper">
        <div className="form-template-header__title form__group form">
          <TextField
            fieldID="title"
            value={title}
            fieldIdentifier="form-title"
            fieldName="Form title"
            handleChange={(event) => handleTemplateChange(event.target.value, 'title')}
            fieldRequired
            handleClick={() => handleTemplateHeaderOnClick('title')}
            handleBlur={() => handleTemplateHeaderOnBlur('title')}
            showError={validateTemplateHeader.title?.isError || false}
            errorMessage={validateTemplateHeader.title?.errorMessage || ''}
            disabled={readOnly}
            autoComplete="off"
          />
        </div>
      </div>
      <div className="form__group-wrapper">
        <div className="form-template-header__title form__group form">
          <TextField
            fieldID="description"
            value={hasValue(description) ? description : ''}
            fieldIdentifier="form-description"
            fieldName="Form description"
            handleChange={(event) => handleTemplateChange(event.target.value, 'description')}
            fieldRequired={false}
            handleClick={() => handleTemplateHeaderOnClick('description')}
            handleBlur={() => handleTemplateHeaderOnBlur('description')}
            showError={validateTemplateHeader.description?.isError || false}
            errorMessage={validateTemplateHeader.description?.errorMessage || ''}
            disabled={readOnly}
            autoComplete="off"
          />
        </div>
      </div>
    </>
  );
}

FormTemplateHeader.propTypes = {
  formTemplate: PropTypes.shape({
    description: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  handleTemplateChange: PropTypes.func.isRequired,
  handleTemplateHeaderOnBlur: PropTypes.func.isRequired,
  handleTemplateHeaderOnClick: PropTypes.func.isRequired,
  validateTemplateHeader: PropTypes.shape({
    title: PropTypes.shape({
      errorMessage: PropTypes.string,
      isError: PropTypes.bool,
    }),
    description: PropTypes.shape({
      errorMessage: PropTypes.string,
      isError: PropTypes.bool,
    }),
  }).isRequired,
  readOnly: PropTypes.bool,
};

export default FormTemplateHeader;
